import { FormHelperText } from '@mui/material';
import { FieldErrors } from 'react-hook-form';
import { themeColors as COLORS } from '@act/toolkit/styles/colors';
import { parseError } from '../form-utils/errorParser.util';

interface FormErrorHelperProps {
  /**
   * The name of the input field
   */
  name: string;
  /**
   * Additional styles for the helper text
   */
  additionalStyles?: { [key: string]: string };
  /**
   * React hook form errors for the controlled form
   */
  errors?: FieldErrors<unknown>;
}

const FormErrorHelper = ({
  name,
  additionalStyles,
  errors,
}: FormErrorHelperProps) => {
  return (
    <FormHelperText
      sx={{
        ...(additionalStyles && { ...additionalStyles }),
        paddingLeft: '16px',
        color: COLORS.error,
      }}
    >
      {parseError(name, errors)['message'] as string}
    </FormHelperText>
  );
};

export default FormErrorHelper;
